exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#cmy-overlay{display:none;z-index:5000;position:relative}#cmy-overlay .cmy-close{background-color:#fff;border:4px solid #505050;border-radius:20px 20px 20px 20px;box-shadow:1px 0 8px -4px #242424;color:#505050;font-size:24px;font-weight:700;height:19px;padding:6px 6px 6px 8px;width:19px;cursor:pointer;margin-top:-30px;right:-30px;position:absolute;z-index:99;font-family:Verdana;box-sizing:content-box}#cmy-overlay .cmy-close:hover{text-decoration:none}#cmy-overlay .cmy-close>div{line-height:80%;margin-left:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/Overlay/main.less
// module id = 17
// module chunks = 0